import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import './index.css';
import Layout from './components/Layout';
import { AuthProvider } from './contexts/AuthContext';

import Home from './pages/Home';
import ServicesIndex from './pages/ServicesIndex';
import ServicePage from './pages/ServicePage';
import CoveragePage from './pages/CoveragePage';
import LocationDispatcher from './pages/LocationDispatcher';
import About from './pages/About';
import ServiceAreas from './pages/ServiceAreas';
import Reviews from './pages/Reviews';
import Contact from './pages/Contact';
import QuotePage from './pages/QuotePage';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminSubscribers from './pages/AdminSubscribers';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" />
        <Routes>
          {/* Admin (no Layout) */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/subscribers" element={<AdminSubscribers />} />

          {/* Main site (with Layout) */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesIndex />} />
            <Route path="/services/:slug" element={<ServicePage />} />

            <Route path="/coverage" element={<ServiceAreas />} />
            <Route path="/coverage/:slug" element={<CoveragePage />} />

            <Route path="/about" element={<About />} />
            <Route path="/service-areas" element={<ServiceAreas />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/quote" element={<QuotePage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />

            {/* Catch-all dispatches legacy dash-prefixed URLs (e.g. /removals-greenwich) */}
            <Route path="*" element={<LocationDispatcher />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
